{
  "longPressMessage": "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
}
